import { Center, Spinner } from '@chakra-ui/react'
import React from 'react'

export const LoadingSpinner = () => {
  return <Center><Spinner size="xl" /></Center>
}
